import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  title,
  subtitle,
  className = ""
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-189" data-mp="vybiypkkv22s">
      <h2 className="font-serif text-[30px] font-semibold leading-[1.15] text-wine sm:text-4xl lg:text-[44px]" data-id="element-190" data-mp="ry1bf8h503lt">
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-base leading-relaxed text-ink sm:text-lg" data-id="element-191" data-mp="mzzjdy1qgty7">{subtitle}</p>}
    </div>;
}
export function Accent({
  children,
  italic = false
}: {
  children: React.ReactNode;
  italic?: boolean;
}) {
  return <span className={`text-rose ${italic ? "italic" : ""}`} data-id="element-192" data-mp="d6irx0p2jqxp">{children}</span>;
}